import {
  Autocomplete,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Controller } from "react-hook-form";
import PermissionCheck from "./PermissionCheck/PermissionCheck";
import { HelperTextComponent } from "./HelperTextComponent";

const DynamicForm = (props: any) => {
  const { fieldsJson, errors, register, control, groups } = props;

  const fieldsFormation = (data: any) => {
    const fields: Array<any> = data?.map((item: any, index: any) => {
      switch (item.inputType) {
        case "dropdown":
          return (
            <PermissionCheck
              permission={item.visibility || "true"}
              key={`${item.name}-${index}`}
            >
              <Grid
                item
                xs={12}
                md={item.size || 12}
                sm={item.size || 12}
                key={`${item.name}-${index}`}
              >
                <Controller
                  name={item.fieldName}
                  control={control}
                  {...register(item.name)}
                  render={({ field: { name, ref, value, onChange } }) => {
                    return (
                      <FormControl
                        fullWidth
                        sx={{ mt: 2 }}
                        required={item.required}
                        error={!!errors[item?.name]}
                      >
                        <InputLabel id={item.name}>{item.label}</InputLabel>
                        <Select
                          labelId={item.name}
                          label="Category"
                          variant="standard"
                          placeholder="All"
                          value={value || ""}
                          multiple={item.multiple ? true : false}
                          onChange={(e) => {
                            return onChange(e.target.value || undefined);
                          }}
                          required={item.required}
                          inputRef={ref}
                          id={item.name}
                        >
                          <MenuItem value="">
                            <em>Clear Values</em>
                          </MenuItem>
                          {item.options.map((option: any, index: any) => (
                            <MenuItem value={option.value} key={index}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        {!!errors[item?.name] && (
                          <FormHelperText>
                            {errors[item?.name].message}
                          </FormHelperText>
                        )}
                      </FormControl>
                    );
                  }}
                />
              </Grid>
            </PermissionCheck>
          );
        case "autocomplete":
          return (
            <PermissionCheck
              permission={item.visibility || "true"}
              key={`${item.name}-${index}`}
            >
              <Grid item xs={12} md={item.size || 12} sm={item.size || 12}>
                <Controller
                  name={item.name}
                  control={control}
                  {...register(item.name)}
                  render={({
                    field: { ref, onChange, value },
                    fieldState: { error },
                  }) => (
                    <Autocomplete
                      options={item?.options || []}
                      value={value}
                      getOptionLabel={(option) =>
                        option?.label || option?.code_list_value || option || ""
                      }
                      isOptionEqualToValue={(option, value) => {
                        return (
                          option == value ||
                          option?.code_list_value == value?.code_list_value
                        );
                      }}
                      freeSolo={item.freeSolo}
                      onChange={(event, newValue) => {
                        onChange(newValue ?? null);
                      }}
                      multiple={item.multiple ? true : false}
                      id={item.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={item.label}
                          variant="standard"
                          error={!!errors[item?.name]}
                          helperText={errors[item?.name]?.message}
                          id={item.name}
                          required={item.required}
                          inputRef={ref}
                          margin="normal"
                        />
                      )}
                    />
                  )}
                />
              </Grid>
            </PermissionCheck>
          );
        case "customComponent":
          return (
            <PermissionCheck
              permission={item.visibility || "true"}
              key={`${item.name}-${index}`}
            >
              <Grid item md={12} xs={12}>
                {item.component}
              </Grid>
            </PermissionCheck>
          );
        case "checkbox":
          return (
            <Grid
              item
              xs={12}
              md={item.size || 12}
              sm={item.size || 12}
              key={`${item.name}-${index}`}
            >
              <FormControlLabel
                control={
                  <Controller
                    name={item.name}
                    control={control}
                    {...register(item.name)}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        checked={field.value}
                        id={field.name}
                        required={item.required}
                      />
                    )}
                  />
                }
                label={item.label}
              />
            </Grid>
          );
        case "radio":
          return (
            <Grid
              item
              xs={12}
              md={item.size || 12}
              sm={item.size || 12}
              key={`${item.name}-${index}`}
            >
              <FormLabel component="legend" required={item.required}>
                {item.label}
              </FormLabel>
              <Controller
                name={item.name}
                control={control}
                {...register(item.name)}
                required={item.required}
                render={({ field }) => (
                  <FormControl>
                    <RadioGroup
                      {...field}
                      id={item.name}
                      row={item?.optionFlex == "row"}
                    >
                      {item.options?.map((option: any) => (
                        <FormControlLabel
                          key={option}
                          value={option}
                          control={<Radio />}
                          label={option}
                          id={option}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                )}
              />
            </Grid>
          );
        case "number":
          return (
            <Grid
              item
              xs={12}
              md={item.size || 12}
              sm={item.size || 12}
              key={`${item.name}-${index}`}
            >
              <Controller
                name={item.name}
                control={control}
                {...register(item.name)}
                render={({ field: { ref, ...newField } }) => (
                  <TextField
                    {...newField}
                    margin="normal"
                    type={item.type || "number"}
                    variant="standard"
                    fullWidth
                    disabled={item.disabled}
                    id={item.name}
                    label={item.label}
                    error={!!errors[item?.name]}
                    helperText={errors[item?.name]?.message}
                    inputProps={{ maxLength: item.maxlength }}
                    required={item.required}
                    onChange={(e) => {
                      const value = e.target.value;
                      newField.onChange(value ? parseFloat(value) : "");
                    }}
                    inputRef={ref}
                    onKeyDown={(e: any) => {
                      const charCode = e.which ? e.which : e.keyCode;
                      if (
                        (item.type == "tel" &&
                          charCode > 40 &&
                          (charCode < 48 || charCode > 57)) ||
                        [
                          "!",
                          "@",
                          "#",
                          "$",
                          "%",
                          "^",
                          "&",
                          "*",
                          "(",
                          ")",
                        ].includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                )}
              />
            </Grid>
          );
        case "date":
          return (
            <Grid
              item
              xs={12}
              md={item.size || 12}
              sm={item.size || 12}
              key={`${item.name}-${index}`}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name={item.name}
                  control={control}
                  {...register(item.name)}
                  id={item.name}
                  render={({ field }) => {
                    return (
                      <DatePicker
                        {...field}
                        disablePast={item.isDisablePast}
                        disableFuture={item.isDisableFuture}
                        value={
                          field.value ? dayjs(field.value, "YYYY-MM-DD") : null
                        }
                        label={item.label}
                        onChange={(date) =>
                          field.onChange(
                            date ? date.format("YYYY-MM-DD") : null
                          )
                        }
                        slotProps={{
                          textField: {
                            id: item.name,
                            variant: "standard",
                            fullWidth: true,
                            required: item.required,
                            error: !!errors[item?.name],
                            helperText: errors[item?.name]
                              ? errors[item?.name]?.message
                              : "",
                          },
                        }}
                      />
                    );
                  }}
                />
              </LocalizationProvider>
            </Grid>
          );
        default:
          return (
            <PermissionCheck permission={item.visibility || "true"}>
              <Grid
                item
                xs={12}
                md={item.size || 12}
                sm={item.size || 12}
                key={`${item.name}-${index}`}
              >
                <Controller
                  name={item.name}
                  control={control}
                  {...register(item.name)}
                  render={({ field: { ref, ...newField } }) => (
                    <TextField
                      {...newField}
                      margin="normal"
                      fullWidth
                      id={item.name}
                      label={item.label}
                      variant="standard"
                      defaultValue={item.defaultValue}
                      inputProps={{
                        maxLength: item.maxlength,
                        form: { autocomplete: item.autocomplete },
                      }}
                      {...register(item.name)}
                      error={!!errors[item?.name]}
                      helperText={
                        errors[item?.name]?.message ||
                        (!item.wordCount &&
                          newField?.value?.length === item?.maxlength &&
                          item?.maxlength > 0 && (
                            <HelperTextComponent mlength={item.maxlength} />
                          )) ||
                        (item.wordCount &&
                          `${newField?.value?.length || 0}/${item.maxlength}`)
                      }
                      disabled={item.disabled}
                      multiline={item.isMultiline}
                      minRows={item.minRows}
                      maxRows={item.maxRows}
                      required={item.required}
                      inputRef={ref}
                      InputProps={item.InputProps}
                      type={item.type}
                    />
                  )}
                />
              </Grid>
            </PermissionCheck>
          );
      }
    });
    return fields;
  };

  return (
    <>
      {groups ? (
        fieldsJson?.map((group: any, index: number) => (
          <Card
            key={group?.groupName || props.key || index}
            sx={{ p: 2, mb: 2 }}
          >
            {group.title && (
              <Typography variant="h6" sx={{ mb: 1 }} component="div">
                {group.title}
              </Typography>
            )}

            <Grid container columnSpacing={3}>
              {fieldsFormation(group?.fields)}
            </Grid>
          </Card>
        ))
      ) : (
        <Grid container columnSpacing={3} key={props.key}>
          {fieldsFormation(fieldsJson)}
        </Grid>
      )}
    </>
  );
};

export default DynamicForm;
